import styled from "styled-components";

export const MobileStrategyControlCardContainer = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
  background: ${({ theme }) => theme.card.bg.quaternary};
  border-radius: 10px;

  &.ineligible-row {
    background-color: ${({ theme }) => theme.table.bg.primary};
    padding-bottom: 5px;
  }

  .header {
    padding-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-broker {
      height: 35px;
      margin-right: 10px;
    }

    .name {
      color: ${({ theme }) => theme.global.color.bodyColor};
      font-weight: 700;
      font-size: 16px;
    }
  }

  .eligibility {
    font-size: 12px;
    color: ${({ theme }) => theme.global.color.bodyColor};
    padding: 0 10px;
    text-align: center;
    font-weight: 400;
    font-style: italic;
  }

  .details-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 10px;

    .status {
      color: ${({ theme }) => theme.card.bg.septenary};
      background: ${({ theme }) => theme.card.bg.septenary};
      padding: 5px 10px;
      font-weight: 600;
      font-size: 14px;
    }
  }
`;
